function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { element, node, shape, func, string } from "prop-types";
import { components } from "react-select";
import classNamesMaker from "classnames";
import { MultiValueCustom } from "#library/components/SelectFilter/customComponents/MultiValue/MultiValueCustom";
import { CellApply } from "#library/components/SelectFilter/customComponents/CellApply/CellApply";
import styles from "./MenuList.module.css";
export var MenuListTags = function MenuListTags(props) {
  var blurInput = props.blurInput,
    children = props.children,
    clearValue = props.clearValue,
    closeMenu = props.closeMenu,
    getValue = props.getValue,
    _props$selectProps = props.selectProps,
    informationCell = _props$selectProps.informationCell,
    linkCell = _props$selectProps.linkCell,
    clearLabel = _props$selectProps.clearLabel,
    applyLabel = _props$selectProps.applyLabel,
    _onApply = _props$selectProps.onApply;
  var selectedOptions = getValue();
  var tagsBlockClassNames = classNamesMaker(styles["jds-MenuList__block"], styles["jds-MenuList__tagBlock"]);
  return /*#__PURE__*/React.createElement(components.MenuList, props, selectedOptions.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: tagsBlockClassNames
  }, /*#__PURE__*/React.createElement(MultiValueCustom, _extends({
    selectedValues: selectedOptions
  }, props))), informationCell && /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, informationCell), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, children), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__footer"]
  }, linkCell && /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, linkCell), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, /*#__PURE__*/React.createElement(CellApply, {
    onApply: function onApply() {
      _onApply(selectedOptions);

      // should delay close menu to not be on the same rendering timing as onApply
      setTimeout(function () {
        blurInput();
        closeMenu();
      }, 300);
    },
    disabled: selectedOptions.length === 0,
    clearLabel: clearLabel,
    applyLabel: "".concat(applyLabel, " (").concat((selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) || "0", ")"),
    onClear: clearValue
  }))));
};
MenuListTags.propTypes = {
  children: node.isRequired,
  selectProps: shape({
    informationCell: element,
    linkCell: element,
    clearLabel: string,
    applyLabel: string,
    onApply: func
  }).isRequired,
  getValue: func.isRequired,
  setValue: func.isRequired,
  clearValue: func.isRequired,
  closeMenu: func.isRequired,
  blurInput: func.isRequired
};